import { render, staticRenderFns } from "./Unauthorized.vue?vue&type=template&id=5ba3d2ec&scoped=true&lang=pug&"
import script from "./Unauthorized.vue?vue&type=script&lang=js&"
export * from "./Unauthorized.vue?vue&type=script&lang=js&"
import style0 from "./Unauthorized.vue?vue&type=style&index=0&id=5ba3d2ec&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba3d2ec",
  null
  
)

export default component.exports